import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

import { getCurrentUserRoles } from "~/auth/api/get-current-user-roles";
import { UserRole } from "~/auth/types/roles";

const getCurrentUserRolesQueryOptions = queryOptions({
  queryKey: ["current-user-roles"],
  queryFn: getCurrentUserRoles,
});

function useCurrentUserRoles<TSelect = UserRole[]>(
  select?: (data: UserRole[]) => TSelect,
) {
  return useSuspenseQuery({
    ...getCurrentUserRolesQueryOptions,
    select,
  });
}

export { getCurrentUserRolesQueryOptions, useCurrentUserRoles };
